import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { getWorkshopTypeList, getWorkshopById, saveWorkshop, deleteWorkshopById, sendNotificationToJobSeekers } from '../../../Services/WorkshopServices';
import moment from 'moment';


export type WorkshopFormValues = {
    [key: string]: any;
}

export type WorkshopFormRef = {
    [key: string]: React.RefObject<HTMLElement | null>
}

export type WorkshopFormErrors = {
    [key: string]: string;
}

export type WorkshopFormTouched = {
    [key: string]: boolean;
}

export type ValidtionFunctions = {
    [key: string]: Function;
}

export type WorkshopFormMasterData = [
    {
        id: string,
        displayName: string
    }
];

export type WorkshopFormData = {
    workshopId: number;
    workshopTypeId: string | null;
    workshopDate: string | null;
    startDate: string | null;
    endDate: string | null;
    workshopMode: string | null;
    location: string | null;
    meetingInformation: string | null;
    meetingInformationContext: string | null;
    roomNumber: string | null;
}

export function useEditWorkshopForm() {

    const history = useHistory();

    let { WId } = useParams<{ WId: string }>();

    useEffect(() => {
        if (WId !== '0') {
            fetchMasterData();
            fetchData(WId);
            requestCount.current = 2;
        } else {
            fetchMasterData();
            requestCount.current = 1;
        }

    }, []);

    async function fetchData(WId?: string) {
        try {
            //get worlshop data by workshopId
            if (WId) {
                const id: number = parseInt(WId);
                getWorkshopById(id, false).then((response) => {
                    if (response && response.status === 200 && response.data) {
                        let data = response.data as WorkshopFormData;
                        let newFormValues = _.cloneDeep(defaultValues);
                        newFormValues.workshopTypeId = data.workshopTypeId;
                        newFormValues.workshopDate = moment(data.workshopDate).format('yyyy-MM-DD');
                        newFormValues.startDate = moment(data.startDate).format('hh:mm A');
                        newFormValues.endDate = moment(data.endDate).format('hh:mm A');
                        newFormValues.meetingInformation = data.meetingInformation;
                        newFormValues.workshopMode = data.workshopMode;
                        newFormValues.meetingInformationContext = data.meetingInformationContext;
                        newFormValues.location = data.location;
                        newFormValues.roomNumber = data.roomNumber;
                        setValues(newFormValues);
                        _handleRequestCountChange('DONE');
                    } else {
                        throw new Error('Unable to fetch Employer Spotlight Workshop data!');
                    }

                })

            }

        } catch (error) {
            _handleRequestCountChange('FAIL');
            Swal.fire(
                {
                    icon: 'error',
                    title: 'Error While Processing',
                    text: `Unable to get data for the form.`,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    confirmButtonColor: '#1678c2'
                }
            ).then(() => {
            });
        }

    }
    async function fetchMasterData() {
        try {
            //get Workshop mode master

            getWorkshopTypeList(false).then((response) => {

                if (response && response.status === 200 && response.data) {
                    let newData: WorkshopFormMasterData = response.data as WorkshopFormMasterData;
                    setMasterData(newData);
                    _handleRequestCountChange('DONE');
                } else {
                    throw new Error('Unable to fetch Employer Spotlight Workshop Master data!');
                }

            })
        } catch (error) {
            _handleRequestCountChange('FAIL');
            Swal.fire(
                {
                    icon: 'error',
                    title: 'Error While Processing',
                    text: `Unable to get master data for the form.`,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    confirmButtonColor: '#1678c2'
                }
            ).then(() => {
            });
        }

    }

    function _handleRequestCountChange(type: 'DONE' | 'FAIL') {
        if (type === 'DONE') {
            requestCount.current -= 1;
        }
        if (requestCount.current === 0 && dataLoaded !== true) {
            setDataLoaded(true);
        }
    }

    const defaultValues: WorkshopFormValues = {
        workshopTypeId: null,
        workshopDate: '',
        startDate: '',
        endDate: '',
        workshopMode: 'Online',
        location: '',
        roomNumber: '',
        meetingInformation: '',
        meetingInformationContext:'',
    };
    const validations = {

        workshopTypeId: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.workshopTypeId && values.workshopTypeId > 0)) {
                        error = 'Please select Workshop type';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },

        workshopDate: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.workshopDate) {
                        error = 'Please enter Workshop Date';
                    } else if (!_isValidDate(values.workshopDate)) {
                        error = 'Please enter a valid date, format like "mm/dd/yyyy"';
                    } else if (_isValidDate(values.workshopDate) && moment(values.workshopDate).isBefore(moment(), 'day')) {
                        error = 'Workshop date should not early than today.'
                    }

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        startDate: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.startDate) {
                        error = 'Please enter start time';
                    } else if (!_isValidTime(values.startDate)) {
                        error = 'Please enter a valid start time: format as "09:00 AM", and specify AM/PM'
                    }


                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        endDate: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.endDate) {
                        error = 'Please enter end time'
                    }
                    else if (!_isValidTime(values.endDate)) {
                        error = 'Please enter a valid end time: format as "09:00 AM", and specify AM/PM'
                    } else if (_isValidTime(values.endDate) && _isValidTime(values.startDate)) {
                        let formatedStartTime = _addSpaceBeforeChar(values.startDate);
                        let formatedEndTime = _addSpaceBeforeChar(values.endDate);
                        const today = moment().format('yyyy-MM-DD ');
                        if (moment(today + formatedEndTime, 'YYYY-MM-DD hh:mm:ss a').isBefore(moment(today + formatedStartTime, 'YYYY-MM-DD hh:mm:ss a'), 'minute')) {
                            error = 'End time should not earlier than start time'
                        }

                    }

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },

        workshopMode: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.workshopMode) {
                        error = 'Please select Workshop Mode';
                    }

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        location: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        roomNumber: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        meetingInformation: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        meetingInformationContext: async function (values: WorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },


    }

    let isSubmit = false;
    const debounceTime = 250;
    const ref = useRef(initRefs(defaultValues));
    const [values, setValues] = useState<WorkshopFormValues>(defaultValues);
    const [errors, setErrors] = useState<WorkshopFormErrors>({});
    const [touched, setTouched] = useState<WorkshopFormTouched>({});
    //const debouncedValidateForm = _.debounce(validateForm, debounceTime);
    const debouncedValidateForm = validateForm;
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [masterData, setMasterData] = useState<WorkshopFormMasterData | null>(null);
    const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);
    const requestCount = useRef<number>(0);
    const [dataLoaded, setDataLoaded] = useState<boolean>(false);

    let validationCount = 0;
    let validationTotal = 1;

    function initRefs(viewModel: WorkshopFormValues) {
        if (viewModel == null) {
            return {};
        } else {
            let result: WorkshopFormRef = {};
            Object.keys(viewModel).forEach((key) => {
                result[key] = React.createRef<HTMLElement | null>();
            });
            return result;
        }
    }

    function registerRef(ref: HTMLElement | null) {
        console.log(ref);
        console.log(typeof ref);
    }

    function touchAll() {
        let keys = Object.keys(defaultValues);
        keys.forEach((key) => {
            touched[key] = true;
        });
        setTouched(touched);
    }

    function counterHit(currentError: WorkshopFormErrors) {
        validationCount += 1;
        // we did not handle timeout problem, but it will in future
        if (validationCount === validationTotal) {
            validationCount = 0;
            if (_.isEmpty(currentError)) {
                setIsValid(true);
                if (isSubmit === true) {
                    isSubmit = false;
                    setIsLoading(true);
                    saveData({ ...values });
                } else {
                    setIsLoading(false);
                }
            } else {
                if (isSubmit === true) {
                    isSubmit = false;
                }
                if (isValid !== false) {
                    setIsValid(false);
                }
                setIsLoading(false);
            }


        }
    }

    function saveData(viewModel: WorkshopFormValues) {
        setIsSubmitting(true);
        setIsLoading(true);
        setErrorMessage(null);
        let newData = _.cloneDeep(viewModel);
        if (WId) {
            newData.workshopId = parseInt(WId);
        } else {
            newData.workshopId = 0;
        }
        let currDate = viewModel.workshopDate + ' ';
        newData.startDate = moment(currDate + _addSpaceBeforeChar(viewModel.startDate)).format();
        newData.endDate = moment(currDate + _addSpaceBeforeChar(viewModel.endDate)).format();
        newData.workshopDate = moment(viewModel.workshopDate).format();
        //console.log(newData);
        saveWorkshop(newData, false).then((res) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (res && res.status === 200) {
                setSubmitSuccess(true);
                //console.log(res);
            } else if (res && res.status === 401) {
                setIsValid(false);
            }
            else {
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${res && res.data ? res.data : "No detail reason available."}`,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                        confirmButtonColor: '#1678c2'
                    }
                ).then(() => {
                });
            }
        }, (error) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (error.response && error.response.data && error.response.status === 500) {
                let footer = '';
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${error.response.data ? error.response.data : "No detail reason available"}`,
                        showConfirmButton: true,
                        footer: footer,
                        confirmButtonText: "OK",
                    }
                ).then(() => {
                });
            }
        });
    }

    function resetForm() {
        Object.keys(defaultValues).forEach((key, index) => {
            let temp = ref.current[key].current;
            if (temp != null) {
                // not implemented yet
            }
        });
        setValues(defaultValues);
        setIsLoading(false);
        setTouched({});
        setErrors({});
    }

    async function handleSubmit() {
        touchAll();
        setIsLoading(true);
        validateForm(values, validations, null);
        isSubmit = true;
    }

    function validateForm(values: WorkshopFormValues, validations: ValidtionFunctions, fieldName: string | null = null) {
        let newErrors: WorkshopFormErrors = {};
        setIsLoading(true);
        if (fieldName != null) {
            // only validate the changing field.Keep current errors info
            newErrors = errors;
            validationTotal = 1;
            validationCount = 0;
            validations[fieldName](values).then(() => {
                delete newErrors[fieldName];
                setErrors(newErrors);
                counterHit(newErrors);
            }, (error: string) => {
                newErrors[fieldName] = error;
                setErrors(newErrors);
                counterHit(newErrors);
            });
        } else {
            // if this validate is not trigered by input control change, validate all.
            let keys = Object.keys(defaultValues);
            validationTotal = keys.length > 0 ? keys.length : 0;
            validationCount = 0;
            keys.forEach((key) => {
                validations[key](values).then(() => {
                    delete newErrors[key];
                    setErrors(newErrors);
                    counterHit(newErrors);
                }, (error: string) => {
                    newErrors[key] = error;
                    setErrors(newErrors);
                    counterHit(newErrors);
                });
            });

        }

    }


    function handleBlur(fieldName: string) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        setTimeout(() => {
            setTouched((prevValue) => {
                return {
                    ...prevValue,
                    [fieldName]: true,
                }
            });
            validateForm(values, validations, null);
        }, 250);
    }

    function handleChange(newValue: any, fieldName: string, fieldOnly = true) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        values[fieldName] = newValue;
        setValues(values);
        if (!(touched[fieldName] != null)) {
            setTouched({ ...touched, [fieldName]: true });
        }
        debouncedValidateForm(values, validations, fieldOnly ? fieldName : null);
    }

    function isValidEmail(testTarget: string) {
        let myReg = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi;
        return myReg.test(testTarget);
    }

    function _isValidTime(testTarget: string) {
        if (!(testTarget && typeof testTarget === 'string' && testTarget.length > 0)) {
            return false;
        }
        let string = testTarget.trim().toLowerCase();
        let myReg = /\d{1,2}:\d{1,2} *(am|pm){1}$/gi;
        let firstTest: boolean = myReg.test(string);
        if (firstTest) {
            string = _addSpaceBeforeChar(string);
            let testMo = moment(moment().format('yyyy-MM-DD ') + string);
            return testMo.isValid();
        } else {
            return false;
        }
    }

    function _addSpaceBeforeChar(s: string): string {
        let result = s.toLowerCase();
        if (result.indexOf('am') !== -1 || result.indexOf('pm') !== -1) {
            let index = result.indexOf('am') == -1 ? result.indexOf('pm') : result.indexOf('am');
            if (index - 1 >= 0 && result[index - 1] != ' ') {
                result = result.slice(0, index)
                    + ' '
                    + result.slice(index);
            }
        }
        return result;
    }

    function _isValidDate(dateText: string): boolean {
        if (!(dateText && typeof dateText === 'string' && dateText.length > 0)) {
            return false;
        } else {
            let testResult = moment(dateText);
            if (!testResult.isValid()) {
                return false;
            }
            return true;
        }
    }

    function handleDelete() {
        const workshopId: number = WId == '0'? 0 : parseInt(WId);
        if ( workshopId !== 0) {
            Swal.fire({
                title: 'Confirm Deletion',
                text: "Would you like to delete this workshop?",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonColor: 'lightgray',
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    setIsSubmitting(true);
                    setIsLoading(true);
                    setErrorMessage(null);
                    deleteWorkshopById(workshopId, false).then((res) => {
                        if (res && res.status === 200) {
                            setTimeout(() => {
                                history.push('/workshopList');
                            }, 200);
                            toastSuccessMessage('Workshop deleted.');
                        }
                    }).catch((error) => {
                        setIsSubmitting(false);
                        setIsLoading(false);
                        console.log(error);
                    });
                }
            })
        }
    }

    function toastSuccessMessage(message: string) {
        Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: 'Success',
            text: message,
            timer: 5000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    function handleSendEmail(){
        sendNotificationToJobSeekers(parseInt(WId)).then((res)=>{
            if(res && res.status === 200){
                toastSuccessMessage('Notifications has been send out.');
            }
        })
    }

    return [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, dataLoaded,
        registerRef, handleChange, handleBlur, handleSubmit, handleDelete, handleSendEmail] as const;

}
